import React from "react";
import './SideColumnScaffold.css';

interface Props{
    sideBarContent: React.ReactNode;
    mainContent: React.ReactNode;
}

function SideColumnScaffold({
    sideBarContent, mainContent
}: Props) : JSX.Element {
    return(
        <div className="side-column-scaffold">
            <div className="side-bar-content">
                {sideBarContent}
            </div>
            <div className="main-content-page">
                {mainContent}
            </div>
        </div>
    )
}

export default SideColumnScaffold;